import PropTypes from 'prop-types';
import SectionDivider from 'modules/common/components/SectionDivider/SectionDivider';
import { formValidationErrorType, statusList } from 'modules/common/enums';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMasterServicesList } from 'modules/masterServices/actions';
// eslint-disable-next-line max-len
import MultiSelectionDropdownMenu from 'modules/common/components/MultiSelectionDropdownMenu/MultiSelectionDropdownMenu';
import DropdownMenu from '../../../common/components/DropdownMenu';
import servicesStrings from '../../strings';
import {
  AddPreparationBtn,
  DeleteIcon,
  FormCheckboxInput,
  FormFieldWrapper,
  FormGrid,
  FormLabel,
  FormTextInput,
  FormValidationError,
  PreparationItemWrapper,
} from './AddOrEditServiceComponent.style';
import FileUploader from '../../../common/components/FileUploader/FileUploader';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const AddOrEditServiceComponent = ({
  formFieldsValues,
  setFormFieldsValues,
  formFieldsValidation,
  masterServicesList,
  specialitiesList,
  subContext,
  serviceKey,
}) => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  const categories = useSelector(state => state.masterServices.categories.details);
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    const body = {
      data: {
        statuskey: 'active',
        categoryKey: subContext,
        pagesize: 100,
      },
    };
    if (subContext) dispatch(fetchMasterServicesList(body));
  }, [dispatch, subContext]);

  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleTextInputFieldChange = (fieldName, fieldEvent, fieldKey) => {
    const { value } = fieldEvent.target;
    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      if (fieldName === 'preparationNameEn' || fieldName === 'preparationNameAr') {
        const preparationObjIndex = fieldsObj.preparations.findIndex(
          preparation => preparation.servicePreparationKey === fieldKey,
        );
        const preparationsArr = [...fieldsObj.preparations];
        preparationsArr[preparationObjIndex][`${fieldName}`] = value;
        fieldsObj.preparations = [...preparationsArr];
      } else if (fieldName === 'cptCode') {
        if (value.length <= 6) fieldsObj[fieldName] = value;
      } else fieldsObj[fieldName] = value;
      return fieldsObj;
    });
  };

  const handleDropDownFieldChange = (fieldName, selectedObj) => {
    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj[fieldName] = selectedObj.key;
      return fieldsObj;
    });
  };

  const handleUploadFileChange = (fieldName, fileList) => {
    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj[fieldName] = fileList?.[0];
      return fieldsObj;
    });
  };

  const handleMultiSelectDropDownFieldChange = (fieldName, selectedObj) => {
    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj[fieldName] = selectedObj;
      return fieldsObj;
    });
  };

  const handleCheckboxFieldChange = (fieldName, value) => {
    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj[fieldName] = value;
      return fieldsObj;
    });
  };

  const handleRemovePreparation = fieldKey => {
    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      const preparationObjIndex = fieldsObj.preparations.findIndex(
        preparation => preparation.servicePreparationKey === fieldKey,
      );
      if (preparationObjIndex !== -1) {
        const updatedPreparations = [
          ...fieldsObj.preparations.slice(0, preparationObjIndex),
          ...fieldsObj.preparations.slice(preparationObjIndex + 1),
        ];
        fieldsObj.preparations = updatedPreparations;
      }
      return fieldsObj;
    });
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <FormGrid>
      <FormFieldWrapper span={2}>
        <FormLabel>{servicesStrings.serviceDetailsContent.cptCodeFieldLabel}*</FormLabel>
        <SectionDivider gap={8} />
        <FormTextInput
          type="text"
          value={formFieldsValues.cptCode}
          onChange={event => handleTextInputFieldChange('cptCode', event)}
        />
        {formFieldsValidation.cptCode === formValidationErrorType.empty && (
          <>
            <SectionDivider gap={4} />
            <FormValidationError>
              {servicesStrings.serviceDetailsContent.formFieldErrorText(
                servicesStrings.serviceDetailsContent.cptCodeFieldLabel,
              )}
            </FormValidationError>
          </>
        )}
      </FormFieldWrapper>
      <FormFieldWrapper>
        <FormLabel>{servicesStrings.serviceDetailsContent.englishNameFieldLabel}*</FormLabel>
        <SectionDivider gap={8} />
        <FormTextInput
          type="text"
          value={formFieldsValues.englishName}
          onChange={event => handleTextInputFieldChange('englishName', event)}
        />
        {formFieldsValidation.englishName === formValidationErrorType.empty && (
          <>
            <SectionDivider gap={4} />
            <FormValidationError>
              {servicesStrings.serviceDetailsContent.formFieldErrorText(
                servicesStrings.serviceDetailsContent.englishNameFieldLabel,
              )}
            </FormValidationError>
          </>
        )}
      </FormFieldWrapper>
      <FormFieldWrapper>
        <FormLabel>{servicesStrings.serviceDetailsContent.arabicNameFieldLabel}*</FormLabel>
        <SectionDivider gap={8} />
        <FormTextInput
          type="text"
          dir="rtl"
          value={formFieldsValues.arabicName}
          onChange={event => handleTextInputFieldChange('arabicName', event)}
        />
        {formFieldsValidation.arabicName === formValidationErrorType.empty && (
          <>
            <SectionDivider gap={4} />
            <FormValidationError>
              {servicesStrings.serviceDetailsContent.formFieldErrorText(
                servicesStrings.serviceDetailsContent.arabicNameFieldLabel,
              )}
            </FormValidationError>
          </>
        )}
      </FormFieldWrapper>
      <FormFieldWrapper span={2}>
        <FormCheckboxInput
          onChange={e => {
            handleCheckboxFieldChange('isPopular', e.target.checked);
          }}
          type="checkbox"
          id="isPopular"
          checked={!!formFieldsValues?.isPopular}
        />
        {/*  eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label htmlFor="isPopular"> Is Popular</label>
      </FormFieldWrapper>
      <FormFieldWrapper span={2}>
        <FormLabel>{servicesStrings.serviceDetailsContent.categoryFieldLabel}</FormLabel>
        <SectionDivider gap={8} />
        <FormTextInput
          type="text"
          value={
            categories?.length > 0 &&
            categories.find(category => category.categoryKey === formFieldsValues.categoryKey)
              ?.categoryNameEn
          }
          disabled
        />
      </FormFieldWrapper>
      <FormFieldWrapper span={2}>
        <FormLabel>{servicesStrings.serviceDetailsContent.statusFieldLabel}</FormLabel>
        <DropdownMenu
          dropdownMenuItemsList={statusList}
          dropdownMenuSelectedObj={statusList.find(type => type.value === formFieldsValues.status)}
          handleDropdownMenuChange={selectedObj => handleDropDownFieldChange('status', selectedObj)}
          objectMapper={{ key: 'value', name: 'name' }}
        />
      </FormFieldWrapper>
      <FormFieldWrapper span={2}>
        <FormLabel>{servicesStrings.serviceDetailsContent.masterServiceFieldLabel}*</FormLabel>
        <DropdownMenu
          dropdownMenuItemsList={masterServicesList}
          dropdownMenuSelectedObj={
            masterServicesList?.length > 0 &&
            masterServicesList.find(
              type => type.masterServiceKey === formFieldsValues.masterService,
            )
          }
          handleDropdownMenuChange={selectedObj =>
            handleDropDownFieldChange('masterService', selectedObj)
          }
          placeholder={
            masterServicesList?.length > 0 ? 'Select a Master Service' : 'No Master Services'
          }
          objectMapper={{ key: 'masterServiceKey', name: 'masterServiceNameEn' }}
        />
        {formFieldsValidation.masterService === formValidationErrorType.empty && (
          <div>
            <SectionDivider gap={4} />
            <FormValidationError>
              {servicesStrings.serviceDetailsContent.formFieldErrorText(
                servicesStrings.serviceDetailsContent.masterServiceFieldLabel,
              )}
            </FormValidationError>
          </div>
        )}
      </FormFieldWrapper>
      <FormFieldWrapper span={2}>
        <FormLabel>{servicesStrings.serviceDetailsContent.specialityFieldLabel}</FormLabel>
        {specialitiesList?.length > 0 && (
          <MultiSelectionDropdownMenu
            dropdownMenuItemsList={specialitiesList}
            dropdownMenuSelectedArr={formFieldsValues.specialities}
            dropdownMenuPlaceholder={
              servicesStrings.serviceDetailsContent.specialityFieldPlaceholder
            }
            handleDropdownMenuChange={value =>
              handleMultiSelectDropDownFieldChange('specialities', value)
            }
            objectMapper={{ key: 'SpecialityKey', name: 'SpecialityNameEnglish' }}
          />
        )}
      </FormFieldWrapper>
      <FormFieldWrapper span={1}>
        <FormLabel>{servicesStrings.serviceDetailsContent.enDetailsFieldLabel}</FormLabel>
        <SectionDivider gap={8} />
        <FormTextInput
          type="text"
          value={formFieldsValues.detailsEn}
          onChange={event => handleTextInputFieldChange('detailsEn', event)}
        />
      </FormFieldWrapper>
      <FormFieldWrapper span={1}>
        <FormLabel>{servicesStrings.serviceDetailsContent.arDetailsFieldLabel}</FormLabel>
        <SectionDivider gap={8} />
        <FormTextInput
          type="text"
          value={formFieldsValues.details}
          onChange={event => handleTextInputFieldChange('details', event)}
        />
      </FormFieldWrapper>
      {serviceKey && (
        <FormFieldWrapper span={2}>
          <FormLabel>{servicesStrings.serviceDetailsContent.addImage}</FormLabel>
          <SectionDivider gap={8} />
          <FileUploader
            key={`files-upload-${formFieldsValues.imageUrl}`}
            single
            operationKey={serviceKey}
            initialUrls={formFieldsValues.imageUrl ? [formFieldsValues.imageUrl] : []}
            changeHandler={files => handleUploadFileChange('imageUrl', files)}
            fileTypes={['image/jpeg', 'image/png', 'image/jpg']}
          />
        </FormFieldWrapper>
      )}
      <FormFieldWrapper span={2}>
        <FormLabel>{servicesStrings.serviceDetailsContent.preparationFieldLabel}</FormLabel>
        <SectionDivider gap={8} />
        {formFieldsValues.preparations.length > 0 &&
          formFieldsValues.preparations.map(preparationItem => (
            <PreparationItemWrapper key={preparationItem.servicePreparationKey}>
              <FormTextInput
                type="text"
                value={preparationItem?.preparationNameEn}
                placeholder={servicesStrings.serviceDetailsContent.preparationFieldLabel}
                onChange={event =>
                  handleTextInputFieldChange(
                    'preparationNameEn',
                    event,
                    preparationItem.servicePreparationKey,
                  )
                }
              />
              <FormTextInput
                type="text"
                dir="rtl"
                value={preparationItem?.preparationNameAr}
                placeholder={servicesStrings.serviceDetailsContent.preparationFieldPlaceholderAr}
                onChange={event =>
                  handleTextInputFieldChange(
                    'preparationNameAr',
                    event,
                    preparationItem.servicePreparationKey,
                  )
                }
              />
              <DeleteIcon
                onClick={() => handleRemovePreparation(preparationItem.servicePreparationKey)}
              />
            </PreparationItemWrapper>
          ))}
        {formFieldsValues.preparations.length <= 4 && (
          <AddPreparationBtn
            onClick={() => {
              const preparationObj = {
                servicePreparationKey: Math.floor(Math.random() * 1000),
                preparationNameEn: '',
                preparationNameAr: '',
              };
              setFormFieldsValues({
                ...formFieldsValues,
                preparations: [...formFieldsValues.preparations, preparationObj],
              });
            }}
          >
            {servicesStrings.serviceDetailsContent.addPreparation}
          </AddPreparationBtn>
        )}
      </FormFieldWrapper>
    </FormGrid>
  );
};
// ###############################################################
// <----------------------- End Return UI ----------------------->
// ###############################################################

AddOrEditServiceComponent.propTypes = {
  formFieldsValues: PropTypes.shape({
    cptCode: PropTypes.string,
    englishName: PropTypes.string,
    arabicName: PropTypes.string,
    categoryKey: PropTypes.string,
    status: PropTypes.string,
    masterService: PropTypes.string,
    isPopular: PropTypes.bool,
    imageUrl: PropTypes.string,
    detailsEn: PropTypes.string,
    preparations: PropTypes.arrayOf({
      preparationNameEn: PropTypes.string,
      preparationNameAr: PropTypes.string,
    }),
    details: PropTypes.string,
    specialities: PropTypes.arrayOf({
      SpecialityKey: PropTypes.string,
      SpecialityNameEnglish: PropTypes.string,
      SpecialityNameArabic: PropTypes.string,
    }),
  }).isRequired,
  setFormFieldsValues: PropTypes.func.isRequired,
  formFieldsValidation: PropTypes.shape({
    cptCode: PropTypes.number,
    englishName: PropTypes.number,
    arabicName: PropTypes.number,
    masterService: PropTypes.number,
  }).isRequired,
  masterServicesList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  specialitiesList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  subContext: PropTypes.string.isRequired,
  serviceKey: PropTypes.string,
};

export default AddOrEditServiceComponent;
